__turbopack_context__.v({
  "content": "Ogdb-module__tp6qNq__content",
  "root": "Ogdb-module__tp6qNq__root",
  "section": "Ogdb-module__tp6qNq__section",
});
